module.exports = __webpack_public_path__ + "static/media/ph_sample_cue.d7a321a5.svg";